import React from "react";
import Context from "./context.js";
import axios from "axios";
import "@kenshooui/react-multi-select/dist/style.css"
import Component from "@reactions/component";
import host from "./host";
import Cookies from "universal-cookie";
import { Pane, Spinner, Dialog, Textarea, Label, Button, SelectField } from 'evergreen-ui'
import { FaShareSquare, FaArrowCircleLeft, FaPhoneAlt, FaPhone, FaUser, FaMapMarkerAlt, FaBoxes, FaClock, FaTruck, FaCalendarAlt, FaUserCog, FaCog, FaCommentDots } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { FcMissedCall, FcApproval, FcCancel, FcPaid, FcRefresh, FcInTransit, FcAssistant, FcShipped } from "react-icons/fc";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment-timezone";
import { Link } from 'react-router-dom';

const cookies = new Cookies();

class Orders extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            data: [],
            count: 0,
            selectedItems: [],
            spinPage: true,
            user_id: 0,
            role: 0,
            users: [],
            showProcessModal: false,
            selectedOrderId: null,
            processType: '',
            postponeDate: '',
            processing: false
        };
    }

    add_call(id) {
        axios({
            method: 'post',
            url: host + `users/order/add/calls/${id}`,
            headers: { 'Authorization': cookies.get("token") },
            data: { order_id: id }
        }).then((response) => {
            this.componentDidMount("لايرد")
        }).catch((error) => {
            console.error(error);
        })
    }

    fixed(id) {
        axios({
            method: 'post',
            url: host + `users/order/fixed/calls/${id}`,
            headers: { 'Authorization': cookies.get("token") },
            data: { order_id: id }
        }).then((response) => {
            // Handle success
        }).catch((error) => {
            console.error(error);
        })
    }

    fixed_delv(id) {
        axios({
            method: 'post',
            url: host + `users/order/fixed/delv/${id}`,
            headers: { 'Authorization': cookies.get("token") },
            data: { order_id: id }
        }).then((response) => {
            // Handle success
        }).catch((error) => {
            console.error(error);
        })
    }

    processOrder = () => {
        if (!this.state.processType) {
            alert('يرجى اختيار نوع المعالجة');
            return;
        }

        if (this.state.processType === 'مؤجل' && !this.state.postponeDate) {
            alert('يرجى إدخال تاريخ التأجيل');
            return;
        }

        this.setState({ processing: true });

        const requestData = {
            id: this.state.selectedOrderId,
            status: this.state.processType,
            Delayed: this.state.processType === 'مؤجل' ? moment(this.state.postponeDate).format("DD/MM/YYYY") : null
        };

        axios({
            method: 'post',
            url: host + `users/mtab3a-orders/update/`,
            headers: { 'Authorization': cookies.get("token") },
            data: requestData
        }).then((response) => {
            this.setState({ 
                processing: false, 
                showProcessModal: false,
                processType: '',
                postponeDate: '',
                selectedOrderId: null
            });
            this.componentDidMount();
            alert('تم معالجة الطلب بنجاح');
        }).catch((error) => {
            console.error(error);
            this.setState({ processing: false });
            alert('حدث خطأ أثناء معالجة الطلب');
        });
    }

    openProcessModal = (orderId) => {
        this.setState({
            showProcessModal: true,
            selectedOrderId: orderId,
            processType: '',
            postponeDate: ''
        });
    }

    closeProcessModal = () => {
        this.setState({
            showProcessModal: false,
            selectedOrderId: null,
            processType: '',
            postponeDate: ''
        });
    }

    handleProcessTypeChange = (value) => {
        this.setState({ 
            processType: value,
            postponeDate: value !== 'مؤجل' ? '' : this.state.postponeDate
        });
    }

    componentDidMount() {
        if (cookies.get("token")) {
            var header = { "Content-Type": "application/json", Authorization: cookies.get("token") };
            const urlParams = new URLSearchParams(window.location.search);
            const number = urlParams.get('number');

            axios.get(host + `users/auth/profile`, { headers: header })
                .then((response) => {
                    if (response.data.data.profile.isBan === true) {
                        window.location.href = '/login';
                    }
                    this.setState({ 
                        role: response.data.data.profile.role, 
                        user_id: response.data.data.profile.id 
                    })
                }).catch(() => {
                    window.location.href = '/login';
                })

            axios.get(host + `users/calls/users/`, { headers: header })
                .then((response) => {
                    this.setState({ users: response.data.users })
                }).catch(() => {
                    window.location.href = '/login';
                })

            axios.get(host + `users/orders/search/check?phone=${number}`, { headers: header })
                .then(res => {
                    let arr = [];
                    for (let i = 0; i < res.data.data.orders.length; i++) {
                        if (res.data.data.orders[i].ordersFormItems) {
                            arr.push(res.data.data.orders[i])
                        }
                    }
                    this.setState({
                        items: arr, 
                        spinPage: false, 
                        data: arr, 
                        count: arr.length
                    });
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            window.location.href = '/login';
        }
    }

    getStatusBadgeStyle(status) {
        switch(status) {
            case 'تم ترحيل الطلب':
                return { background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white' };
            case 'الطلب راجع':
                return { background: 'linear-gradient(135deg, #ef4444, #dc2626)', color: 'white' };
            case 'تم التأكيد':
                return { background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: 'white' };
            case 'مؤجل':
                return { background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: 'white' };
            case 'تم المعالجة':
                return { background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', color: 'white' };
            default:
                return { background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: 'white' };
        }
    }

    render() {
        return (
            <div>
                <style jsx>{`
                    * {
                        box-sizing: border-box;
                        margin: 0;
                        padding: 0;
                    }

                    body {
                        font-family: 'Cairo', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                        direction: rtl;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        min-height: 100vh;
                    }

                    .app-container {
                        min-height: 100vh;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        position: relative;
                        overflow-x: hidden;
                    }

                    .app-container::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
                                    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                                    radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%);
                        pointer-events: none;
                    }

                    .header {
                        background: rgba(255, 255, 255, 0.15);
                        backdrop-filter: blur(20px);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        border-radius: 0 0 40px 40px;
                        padding: 30px 25px;
                        margin: 0 15px 30px 15px;
                        position: relative;
                        z-index: 10;
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    }

                    .header-content {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        max-width: 1200px;
                        margin: 0 auto;
                    }

                    .back-button {
                        background: linear-gradient(135deg, #667eea, #764ba2);
                        color: white;
                        border: none;
                        border-radius: 50%;
                        width: 60px;
                        height: 60px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 24px;
                        cursor: pointer;
                        transition: all 0.4s ease;
                        box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
                        position: relative;
                        overflow: hidden;
                    }

                    .back-button::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        transition: left 0.5s;
                    }

                    .back-button:hover::before {
                        left: 100%;
                    }

                    .back-button:hover {
                        transform: translateY(-3px) scale(1.05);
                        box-shadow: 0 15px 35px rgba(102, 126, 234, 0.6);
                    }

                    .page-title {
                        color: white;
                        font-size: 32px;
                        font-weight: 700;
                        text-align: center;
                        flex: 1;
                        margin: 0 30px;
                        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
                    }

                    .orders-container {
                        padding: 0 15px 30px 15px;
                        max-width: 1400px;
                        margin: 0 auto;
                    }

                    .orders-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
                        gap: 30px;
                        position: relative;
                        z-index: 5;
                    }

                    .order-card {
                        background: rgba(255, 255, 255, 0.95);
                        backdrop-filter: blur(20px);
                        border-radius: 30px;
                        overflow: hidden;
                        position: relative;
                        transition: all 0.4s ease;
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
                    }

                    .order-card::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 6px;
                        background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
                        background-size: 300% 100%;
                        animation: gradientMove 3s ease infinite;
                    }

                    @keyframes gradientMove {
                        0%, 100% { background-position: 0% 50%; }
                        50% { background-position: 100% 50%; }
                    }

                    .order-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);
                    }

                    .order-header {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                        padding: 30px;
                        text-align: center;
                        position: relative;
                        overflow: hidden;
                    }

                    .order-header::before {
                        content: '';
                        position: absolute;
                        top: -50%;
                        left: -50%;
                        width: 200%;
                        height: 200%;
                        background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
                        animation: float 6s ease-in-out infinite;
                    }

                    @keyframes float {
                        0%, 100% { transform: translateY(0px) rotate(0deg); }
                        50% { transform: translateY(-20px) rotate(180deg); }
                    }

                    .order-number {
                        font-size: 28px;
                        font-weight: 800;
                        margin-bottom: 15px;
                        position: relative;
                        z-index: 2;
                    }

                    .status-badge {
                        display: inline-block;
                        padding: 12px 24px;
                        border-radius: 25px;
                        font-size: 14px;
                        font-weight: 700;
                        position: relative;
                        z-index: 2;
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
                        border: 2px solid rgba(255, 255, 255, 0.3);
                    }

                    .order-body {
                        padding: 30px;
                    }

                    .process-button {
                        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                        color: white;
                        border: none;
                        border-radius: 20px;
                        padding: 16px 30px;
                        font-size: 16px;
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        cursor: pointer;
                        transition: all 0.4s ease;
                        margin: 0 auto 25px auto;
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 10px 30px rgba(245, 87, 108, 0.4);
                    }

                    .process-button::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        transition: left 0.5s;
                    }

                    .process-button:hover::before {
                        left: 100%;
                    }

                    .process-button:hover {
                        transform: translateY(-3px) scale(1.05);
                        box-shadow: 0 15px 40px rgba(245, 87, 108, 0.6);
                    }

                    .section {
                        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
                        border-radius: 25px;
                        padding: 25px;
                        margin: 20px 0;
                        border: 1px solid rgba(226, 232, 240, 0.8);
                        position: relative;
                        transition: all 0.3s ease;
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.05);
                    }

                    .section:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
                    }

                    .section-header {
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        margin-bottom: 20px;
                        font-size: 18px;
                        font-weight: 700;
                        color: #2d3748;
                    }

                    .section-icon {
                        background: linear-gradient(135deg, #667eea, #764ba2);
                        color: white;
                        border-radius: 50%;
                        width: 45px;
                        height: 45px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
                        position: relative;
                        overflow: hidden;
                    }

                    .section-icon::before {
                        content: '';
                        position: absolute;
                        top: -50%;
                        left: -50%;
                        width: 200%;
                        height: 200%;
                        background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
                        animation: iconFloat 4s ease-in-out infinite;
                    }

                    @keyframes iconFloat {
                        0%, 100% { transform: scale(1) rotate(0deg); }
                        50% { transform: scale(1.1) rotate(180deg); }
                    }

                    .contact-buttons {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 15px;
                        margin: 20px 0;
                    }

                    .contact-button {
                        padding: 18px;
                        border-radius: 20px;
                        border: none;
                        font-weight: 700;
                        font-size: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        transition: all 0.4s ease;
                        cursor: pointer;
                        text-decoration: none;
                        position: relative;
                        overflow: hidden;
                    }

                    .contact-button::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 0;
                        height: 0;
                        background: rgba(255, 255, 255, 0.3);
                        border-radius: 50%;
                        transition: all 0.5s ease;
                        transform: translate(-50%, -50%);
                    }

                    .contact-button:hover::before {
                        width: 300px;
                        height: 300px;
                    }

                    .phone-button {
                        background: linear-gradient(135deg, #3b82f6, #1d4ed8);
                        color: white;
                        box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
                    }

                    .phone-button:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 12px 35px rgba(59, 130, 246, 0.6);
                    }

                    .whatsapp-button {
                        background: linear-gradient(135deg, #10b981, #059669);
                        color: white;
                        box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
                    }

                    .whatsapp-button:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 12px 35px rgba(16, 185, 129, 0.6);
                    }

                    .info-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 15px;
                    }

                    .info-card {
                        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                        padding: 20px;
                        border-radius: 18px;
                        text-align: center;
                        border: 2px solid rgba(226, 232, 240, 0.5);
                        transition: all 0.3s ease;
                        position: relative;
                        overflow: hidden;
                    }

                    .info-card::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
                        transition: left 0.5s;
                    }

                    .info-card:hover::before {
                        left: 100%;
                    }

                    .info-card:hover {
                        transform: translateY(-5px);
                        border-color: #667eea;
                        box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
                    }

                    .info-label {
                        font-size: 14px;
                        color: #718096;
                        margin-bottom: 8px;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .info-value {
                        font-size: 16px;
                        font-weight: 700;
                        color: #2d3748;
                        position: relative;
                        z-index: 2;
                    }

                    .notification-card {
                        background: linear-gradient(135deg, #fef3c7 0%, #fbbf24 100%);
                        padding: 20px;
                        border-radius: 18px;
                        margin: 15px 0;
                        border: 2px solid rgba(251, 191, 36, 0.3);
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 8px 25px rgba(251, 191, 36, 0.2);
                    }

                    .notification-card::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        transition: left 0.5s;
                    }

                    .notification-card:hover::before {
                        left: 100%;
                    }

                    .notification-content {
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        color: #92400e;
                        font-weight: 700;
                        font-size: 16px;
                        position: relative;
                        z-index: 2;
                    }

                    .notification-icon {
                        background: rgba(146, 64, 14, 0.2);
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                    }

                    .postponed-date-card {
                        background: linear-gradient(135deg, #dbeafe 0%, #3b82f6 100%);
                        padding: 20px;
                        border-radius: 18px;
                        margin: 15px 0;
                        border: 2px solid rgba(59, 130, 246, 0.3);
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 8px 25px rgba(59, 130, 246, 0.2);
                    }

                    .postponed-date-card::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        transition: left 0.5s;
                    }

                    .postponed-date-card:hover::before {
                        left: 100%;
                    }

                    .postponed-date-content {
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        color: white;
                        font-weight: 700;
                        font-size: 16px;
                        position: relative;
                        z-index: 2;
                    }

                    .postponed-date-icon {
                        background: rgba(255, 255, 255, 0.2);
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 18px;
                    }

                    .item-card {
                        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                        padding: 18px;
                        border-radius: 18px;
                        margin: 12px 0;
                        border: 2px solid rgba(226, 232, 240, 0.5);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        transition: all 0.3s ease;
                        position: relative;
                        overflow: hidden;
                    }

                    .item-card::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
                        transition: left 0.5s;
                    }

                    .item-card:hover::before {
                        left: 100%;
                    }

                    .item-card:hover {
                        transform: translateY(-3px);
                        border-color: #667eea;
                        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);
                    }

                    .item-name {
                        font-size: 16px;
                        font-weight: 700;
                        color: #2d3748;
                        position: relative;
                        z-index: 2;
                    }

                    .item-count {
                        background: linear-gradient(135deg, #667eea, #764ba2);
                        color: white;
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-size: 14px;
                        font-weight: 700;
                        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
                        position: relative;
                        z-index: 2;
                    }

                    .shipping-company-badge {
                        background: linear-gradient(135deg, #9f7aea 0%, #805ad5 100%);
                        color: white;
                        display: inline-flex;
                        align-items: center;
                        gap: 12px;
                        padding: 15px 25px;
                        border-radius: 25px;
                        font-size: 16px;
                        font-weight: 700;
                        margin: 15px 0;
                        box-shadow: 0 8px 25px rgba(159, 122, 234, 0.4);
                        position: relative;
                        overflow: hidden;
                    }

                    .shipping-company-badge::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        animation: shimmer 2s infinite;
                    }

                    @keyframes shimmer {
                        0% { left: -100%; }
                        100% { left: 100%; }
                    }

                    .loading-container {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 70vh;
                        background: rgba(255, 255, 255, 0.1);
                        backdrop-filter: blur(20px);
                        border-radius: 30px;
                        margin: 20px;
                        border: 1px solid rgba(255, 255, 255, 0.2);
                    }

                    .modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0, 0, 0, 0.7);
                        backdrop-filter: blur(10px);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 1000;
                        padding: 20px;
                    }

                    .modal-content {
                        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                        border-radius: 25px;
                        padding: 30px;
                        width: 100%;
                        max-width: 450px;
                        max-height: 90vh;
                        overflow-y: auto;
                        position: relative;
                        box-shadow: 0 25px 60px rgba(0, 0, 0, 0.3);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }

                    .modal-header {
                        text-align: center;
                        margin-bottom: 30px;
                        padding-bottom: 20px;
                        border-bottom: 2px solid rgba(102, 126, 234, 0.1);
                    }

                    .modal-title {
                        font-size: 24px;
                        font-weight: 700;
                        color: #2d3748;
                        margin-bottom: 10px;
                    }

                    .modal-subtitle {
                        font-size: 14px;
                        color: #718096;
                        font-weight: 500;
                    }

                    .select-field {
                        margin-bottom: 25px;
                    }

                    .field-label {
                        display: block;
                        font-size: 16px;
                        font-weight: 700;
                        color: #2d3748;
                        margin-bottom: 12px;
                        padding-right: 5px;
                    }

                    .select-field select {
                        width: 100%;
                        padding: 18px 16px;
                        border-radius: 15px;
                        border: 2px solid #e2e8f0;
                        font-size: 16px;
                        font-family: 'Cairo', sans-serif;
                        font-weight: 600;
                        background: white;
                        transition: all 0.3s ease;
                        color: #2d3748;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                        appearance: none;
                        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
                        background-position: left 12px center;
                        background-repeat: no-repeat;
                        background-size: 16px;
                        padding-left: 40px;
                    }

                    .select-field select:focus {
                        outline: none;
                        border-color: #667eea;
                        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
                        transform: translateY(-2px);
                    }

                    .modal-buttons {
                        display: flex;
                        gap: 15px;
                        margin-top: 30px;
                        padding-top: 20px;
                        border-top: 2px solid rgba(102, 126, 234, 0.1);
                    }

                    .modal-button {
                        flex: 1;
                        padding: 16px 20px;
                        border-radius: 15px;
                        border: none;
                        font-size: 16px;
                        font-weight: 700;
                        font-family: 'Cairo', sans-serif;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        position: relative;
                        overflow: hidden;
                    }

                    .modal-button-confirm {
                        background: linear-gradient(135deg, #10b981, #059669);
                        color: white;
                        box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);
                    }

                    .modal-button-confirm:hover:not(:disabled) {
                        transform: translateY(-3px);
                        box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
                    }

                    .modal-button-confirm:disabled {
                        background: #d1d5db;
                        color: #9ca3af;
                        cursor: not-allowed;
                        box-shadow: none;
                    }

                    .modal-button-cancel {
                        background: linear-gradient(135deg, #ef4444, #dc2626);
                        color: white;
                        box-shadow: 0 8px 25px rgba(239, 68, 68, 0.3);
                    }

                    .modal-button-cancel:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 12px 35px rgba(239, 68, 68, 0.5);
                    }

                    .modal-button::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                        transition: left 0.5s;
                    }

                    .modal-button:hover::before {
                        left: 100%;
                    }



                    /* Responsive Design */
                    @media (max-width: 768px) {
                        .orders-grid {
                            grid-template-columns: 1fr;
                            gap: 20px;
                        }

                        .header-content {
                            flex-direction: column;
                            gap: 20px;
                            text-align: center;
                        }

                        .page-title {
                            font-size: 24px;
                            margin: 0;
                        }

                        .contact-buttons {
                            grid-template-columns: 1fr;
                            gap: 12px;
                        }

                        .info-grid {
                            grid-template-columns: 1fr;
                        }

                        .modal-content {
                            max-width: 95vw;
                            padding: 25px 20px;
                            margin: 10px;
                            border-radius: 20px;
                        }

                        .modal-title {
                            font-size: 20px;
                        }

                        .modal-buttons {
                            flex-direction: column;
                            gap: 12px;
                        }

                        .modal-button {
                            padding: 18px 20px;
                            font-size: 16px;
                        }

                        .select-field select {
                            padding: 20px 16px;
                            font-size: 18px;
                            padding-left: 45px;
                        }

                        .field-label {
                            font-size: 18px;
                            margin-bottom: 15px;
                        }

                        .back-button {
                            width: 50px;
                            height: 50px;
                            font-size: 20px;
                        }

                        .order-body {
                            padding: 20px;
                        }

                        .section {
                            padding: 20px;
                        }

                        .contact-button {
                            padding: 15px;
                            font-size: 14px;
                        }

                        .process-button {
                            padding: 14px 25px;
                            font-size: 14px;
                        }

                        .date-picker-wrapper .react-datepicker__input-container input {
                            font-size: 18px;
                            padding: 20px 16px;
                        }
                    }

                    @media (max-width: 480px) {
                        .header {
                            margin: 0 10px 20px 10px;
                            padding: 20px;
                        }

                        .orders-container {
                            padding: 0 10px 20px 10px;
                        }

                        .page-title {
                            font-size: 20px;
                        }

                        .order-number {
                            font-size: 22px;
                        }

                        .section-header {
                            font-size: 16px;
                        }

                        .modal-content {
                            max-width: 98vw;
                            padding: 20px 15px;
                            margin: 5px;
                            border-radius: 15px;
                        }

                        .modal-title {
                            font-size: 18px;
                        }

                        .modal-subtitle {
                            font-size: 13px;
                        }

                        .field-label {
                            font-size: 16px;
                        }

                        .select-field select {
                            padding: 22px 16px;
                            font-size: 16px;
                            padding-left: 45px;
                        }

                        .modal-button {
                            padding: 20px;
                            font-size: 16px;
                        }
                    }
                `}</style>

                <Context.Consumer>
                    {ctx => {
                        return (
                            <div className="app-container">
                                {/* Header */}
                                <div className="header">
                                    <div className="header-content">
                                        <Link to='/'>
                                            <button className="back-button">
                                                <FaArrowCircleLeft />
                                            </button>
                                        </Link>
                                        <h1 className="page-title">معلومات الطلب</h1>
                                        <div style={{ width: '60px' }}></div>
                                    </div>
                                </div>

                                {!this.state.spinPage ? (
                                    <div className="orders-container">
                                        <div className="orders-grid">
                                            {this.state.data.map((item, index) => (
                                                <div key={index} className="order-card">
                                                    {/* Order Header */}
                                                    <div className="order-header">
                                                        <div className="order-number">
                                                            رقم الوصل: {item.id}
                                                        </div>
                                                        <div className="status-badge" style={this.getStatusBadgeStyle(item.status)}>
                                                            {item.status}
                                                        </div>
                                                    </div>

                                                    <div className="order-body">
                                                        {/* التبليغ - Show if calls has value */}
                                                        {item.calls && (
                                                            <div className="notification-card">
                                                                <div className="notification-content">
                                                                    <div className="notification-icon">
                                                                        <FaCommentDots />
                                                                    </div>
                                                                    <div>
                                                                        <strong>التبليغ:</strong> {item.calls}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* تاريخ التأجيل - Show if calls equals مؤجل and Delayed has value */}
                                                        {item.calls === 'مؤجل' && item.Delayed && (
                                                            <div className="postponed-date-card">
                                                                <div className="postponed-date-content">
                                                                    <div className="postponed-date-icon">
                                                                        <FaCalendarAlt />
                                                                    </div>
                                                                    <div>
                                                                        <strong>تاريخ التأجيل:</strong> {
                                                                            moment(item.Delayed, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() 
                                                                                ? moment(item.Delayed, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
                                                                                : item.Delayed
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Contact Section */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaPhone />
                                                                </div>
                                                                معلومات التواصل
                                                            </div>
                                                            <div className="contact-buttons">
                                                                <a 
                                                                    href={`tel:${item.phone}`} 
                                                                    className="contact-button phone-button"
                                                                >
                                                                    <FaPhone />
                                                                    {item.phone}
                                                                </a>
                                                                <button
                                                                    className="contact-button whatsapp-button"
                                                                    onClick={() => {
                                                                        setTimeout(() => {
                                                                            window.location.replace(`https://api.whatsapp.com/send?phone=964${item.phone.slice(1)}`);
                                                                        }, 500);
                                                                    }}
                                                                >
                                                                    <IoLogoWhatsapp />
                                                                    واتساب
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Order Info */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaUser />
                                                                </div>
                                                                معلومات الطلب
                                                            </div>
                                                            <div className="info-grid">
                                                                <div className="info-card">
                                                                    <div className="info-label">مثبت الطلب</div>
                                                                    <div className="info-value">{item.user.name}</div>
                                                                </div>
                                                                <div className="info-card">
                                                                    <div className="info-label">رابط الحساب</div>
                                                                    <div className="info-value">
                                                                        <FaShareSquare 
                                                                            style={{ color: '#667eea', cursor: 'pointer', fontSize: 24 }}
                                                                            onClick={() => window.location.href = item.account} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Customer Info */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaUser />
                                                                </div>
                                                                معلومات الزبون
                                                            </div>
                                                            <div className="info-grid">
                                                                <div className="info-card">
                                                                    <div className="info-label">اسم الزبون</div>
                                                                    <div className="info-value">{item.name}</div>
                                                                </div>
                                                                <div className="info-card">
                                                                    <div className="info-label">اسم البيج</div>
                                                                    <div className="info-value">{item.page_name}</div>
                                                                </div>
                                                                <div className="info-card">
                                                                    <div className="info-label">السعر الكلي</div>
                                                                    <div className="info-value">{item.price}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Items */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaBoxes />
                                                                </div>
                                                                المواد المطلوبة
                                                            </div>
                                                            {item.ordersFormItems.map((orderItem, i) => (
                                                                <div key={i} className="item-card">
                                                                    <div className="item-name">
                                                                        {orderItem.components.name}
                                                                    </div>
                                                                    <div className="item-count">
                                                                        العدد: {orderItem.count}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Address */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaMapMarkerAlt />
                                                                </div>
                                                                العنوان
                                                            </div>
                                                            <div className="info-value">
                                                                {item.government} / {item.city}
                                                            </div>
                                                        </div>

                                                        {/* Shipping Info */}
                                                        <div className="section">
                                                            <div className="section-header">
                                                                <div className="section-icon">
                                                                    <FaTruck />
                                                                </div>
                                                                معلومات الترحيل
                                                            </div>
                                                            <div className="info-grid">
                                                                <div className="info-card">
                                                                    <div className="info-label">تاريخ الترحيل</div>
                                                                    <div className="info-value">
                                                                        {item.printerOrders.length > 0 
                                                                            ? moment(item.printerOrders[0].prints.createdAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')
                                                                            : "لم يتم الترحيل"
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            {/* Shipping Company Badge */}
                                                            {(item.status === "تم ترحيل الطلب" || item.status === "الطلب راجع") && 
                                                             item.printerOrders.length > 0 && (
                                                                <div className="shipping-company-badge">
                                                                    <FcShipped />
                                                                    شركة التوصيل: {item.printerOrders[0].prints.name}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Call Processing Info */}
                                                        {item.orderCall.length > 0 && (
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <div className="section-icon">
                                                                        <FaUserCog />
                                                                    </div>
                                                                    معلومات المعالجة
                                                                </div>
                                                                <div className="info-grid">
                                                                    <div className="info-card">
                                                                        <div className="info-label">المعالج</div>
                                                                        <div className="info-value">{item.orderCall[0].user.name}</div>
                                                                    </div>
                                                                    <div className="info-card">
                                                                        <div className="info-label">تاريخ التحويل</div>
                                                                        <div className="info-value">
                                                                            {moment(item.orderCall[0].createdAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="info-card">
                                                                        <div className="info-label">عدد المحاولات</div>
                                                                        <div className="info-value">{item.call_count}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Process Order Button - Only for role 3 - Moved to bottom */}
                                                        {this.state.role === 3 && (
                                                            <button
                                                                className="process-button"
                                                                onClick={() => this.openProcessModal(item.id)}
                                                                style={{ marginTop: '20px', marginBottom: '0' }}
                                                            >
                                                                <FaCog />
                                                                معالجة الطلب
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="loading-container">
                                        <Spinner size={64} />
                                    </div>
                                )}

                                {/* Process Order Modal */}
                                {this.state.showProcessModal && (
                                    <div className="modal-overlay" onClick={this.closeProcessModal}>
                                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                            <div className="modal-header">
                                                <div className="modal-title">معالجة الطلب</div>
                                                <div className="modal-subtitle">رقم الطلب: {this.state.selectedOrderId}</div>
                                            </div>

                                            <div className="select-field">
                                                <label className="field-label" htmlFor="processType">
                                                    نوع المعالجة
                                                </label>
                                                <select
                                                    id="processType"
                                                    value={this.state.processType}
                                                    onChange={(e) => this.handleProcessTypeChange(e.target.value)}
                                                >
                                                    <option value="">اختر نوع المعالجة</option>
                                                    <option value="لايرد">لايرد</option>
                                                    <option value="خطأ بالتجهيز">خطأ بالتجهيز</option>
                                                    <option value="كاذب">كاذب</option>
                                                    <option value="شركة التوصيل">شركة التوصيل</option>
                                                    <option value="مؤجل">مؤجل</option>
                                                    <option value="تم المعالجة">تم المعالجة</option>
                                                </select>
                                            </div>

                                            {this.state.processType === 'مؤجل' && (
                                                <div>
                                                    <label className="field-label" htmlFor="postponeDate">
                                                        تاريخ التأجيل
                                                    </label>
                                                    <input
                                                        id="postponeDate"
                                                        type="date"
                                                        value={this.state.postponeDate}
                                                        onChange={(e) => this.setState({ postponeDate: e.target.value })}
                                                        min={moment().format('YYYY-MM-DD')}
                                                        style={{
                                                            width: '100%',
                                                            padding: '18px 16px',
                                                            borderRadius: '15px',
                                                            border: '2px solid #e2e8f0',
                                                            fontSize: '16px',
                                                            fontFamily: 'Cairo, sans-serif',
                                                            fontWeight: '600',
                                                            background: 'white',
                                                            transition: 'all 0.3s ease',
                                                            color: '#2d3748',
                                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
                                                        }}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#667eea';
                                                            e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1)';
                                                            e.target.style.transform = 'translateY(-2px)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e2e8f0';
                                                            e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.05)';
                                                            e.target.style.transform = 'translateY(0)';
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <div className="modal-buttons">
                                                <button
                                                    className="modal-button modal-button-confirm"
                                                    onClick={this.processOrder}
                                                    disabled={this.state.processing || !this.state.processType || (this.state.processType === 'مؤجل' && !this.state.postponeDate)}
                                                >
                                                    {this.state.processing ? "جاري المعالجة..." : "تأكيد"}
                                                </button>
                                                <button
                                                    className="modal-button modal-button-cancel"
                                                    onClick={this.closeProcessModal}
                                                    disabled={this.state.processing}
                                                >
                                                    إلغاء
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }}
                </Context.Consumer>
            </div>
        );
    }
}

export default Orders;